import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const flipperItemsApi = createApi({
  reducerPath: "flipperItemsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["FlipperItem"],
  endpoints: (build) => ({
    getFlipperItems: build.query({
      query: ({ itemType, projectId, contractorId, status, limit = 2000 } = {}) => ({
        url: "/flipper/items",
        method: "GET",
        params: { itemType, projectId, contractorId, status, limit },
      }),
      providesTags: ["FlipperItem"],
    }),
    createFlipperItem: build.mutation({
      query: (data) => ({ url: "/flipper/items", method: "POST", body: data }),
      invalidatesTags: ["FlipperItem"],
    }),
    bulkCreateFlipperItems: build.mutation({
      query: ({ items }) => ({ url: "/flipper/items/bulk", method: "POST", body: { items } }),
      invalidatesTags: ["FlipperItem"],
    }),
    updateFlipperItem: build.mutation({
      query: ({ id, ...data }) => ({ url: `/flipper/items/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["FlipperItem"],
    }),
    deleteFlipperItem: build.mutation({
      query: (id) => ({ url: `/flipper/items/${id}`, method: "DELETE" }),
      invalidatesTags: ["FlipperItem"],
    }),
  }),
});

export const {
  useGetFlipperItemsQuery,
  useCreateFlipperItemMutation,
  useBulkCreateFlipperItemsMutation,
  useUpdateFlipperItemMutation,
  useDeleteFlipperItemMutation,
} = flipperItemsApi;
